export const KA_STATUS_KEYS = {
  notStarted: "notStarted",
  complete: "complete",
  overdue: "overdue",
  inProgress: "inProgress",
  archived: "archived",
} as const;

export type KaStatusKey = (typeof KA_STATUS_KEYS)[keyof typeof KA_STATUS_KEYS];

export interface StatusConfigEntry {
  icon: string;
  /** PrimeReact severity string or themeClasses key; "warning" is resolved to themeClasses.textWarning by consumers */
  color: string;
}

export const STATUS_CONFIG: Record<KaStatusKey, StatusConfigEntry> = {
  [KA_STATUS_KEYS.complete]: { icon: "pi-check-circle", color: "" },
  [KA_STATUS_KEYS.inProgress]: { icon: "pi-spinner-dotted pi-spin", color: "" },
  [KA_STATUS_KEYS.overdue]: { icon: "pi-exclamation-circle", color: "warning" },
  [KA_STATUS_KEYS.notStarted]: { icon: "", color: "" },
  [KA_STATUS_KEYS.archived]: { icon: "pi-box", color: "" },
};

export const STATUS_LABEL_MAP: Record<string, string> = {
  [KA_STATUS_KEYS.notStarted]: "Not Started",
  [KA_STATUS_KEYS.complete]: "Complete",
  [KA_STATUS_KEYS.inProgress]: "In Progress",
  [KA_STATUS_KEYS.overdue]: "Overdue",
  [KA_STATUS_KEYS.archived]: "Archived",
};
